import styles from "./videoControls.module.scss";

interface VideoControlsProps {
  muted: boolean;
  paused: boolean;
  onToggleMute: () => void;
  onTogglePause: () => void;
}

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <rect x="6" y="5" width="4" height="14" fill="currentColor" />
    <rect x="14" y="5" width="4" height="14" fill="currentColor" />
  </svg>
);

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <path d="M7 5v14l12-7z" fill="currentColor" />
  </svg>
);

const SpeakerIcon = ({ muted }: { muted: boolean }) => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 9v6h4l5 4V5L8 9z" fill="currentColor" />
    {muted ? (
      <path d="M16 9l5 6M21 9l-5 6" />
    ) : (
      <path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" />
    )}
  </svg>
);

const VideoControls = ({
  muted,
  paused,
  onToggleMute,
  onTogglePause,
}: VideoControlsProps) => (
  <div className={styles.controls}>
    <button
      type="button"
      className={styles.button}
      onClick={onTogglePause}
      aria-label={paused ? "Play video" : "Pause video"}
    >
      {paused ? <PlayIcon /> : <PauseIcon />}
    </button>
    <button
      type="button"
      className={styles.button}
      onClick={onToggleMute}
      aria-label={muted ? "Unmute video" : "Mute video"}
    >
      <SpeakerIcon muted={muted} />
    </button>
  </div>
);

export default VideoControls;
